module.exports = __webpack_public_path__ + "static/media/yuangongdengjibiao1.4677b76a.png";